import { types } from './actions';

const initialState = {
  isStripeAccountBeingCreated: false,
  isOnboardingUrlFetching: false,
};

const reducer = (state = initialState, action) => {
  const { type } = action;
  switch (type) {
    case types.CREATE_STRIPE_ACCOUNT_ERROR:
      return {
        ...state,
        isStripeAccountBeingCreated: false,
      };
    case types.CREATE_STRIPE_ACCOUNT_REQUEST:
      return {
        ...state,
        isStripeAccountBeingCreated: true,
      };
    case types.CREATE_STRIPE_ACCOUNT_SUCCESS:
      return {
        ...state,
        isStripeAccountBeingCreated: false,
      };
    case types.GET_STRIPE_ONBOARDING_LINK_ERROR:
      return {
        ...state,
        isOnboardingUrlFetching: false,
      };
    case types.GET_STRIPE_ONBOARDING_LINK_REQUEST:
      return {
        ...state,
        isOnboardingUrlFetching: true,
      };
    case type.GET_STRIPE_ONBOARDING_LINK_SUCCESS:
      return {
        ...state,
        isOnboardingUrlFetching: false,
      };
    default:
      return state;
  }
};

export default reducer;

const getScope = (state) =>
  state.modules.settings.accounting.bankingInformation;

export const isStripeAccountBeingCreated = (state) =>
  getScope(state).isStripeAccountBeingCreated;

export const isOnboardingUrlFetching = (state) =>
  getScope(state).isOnboardingUrlFetching;
